import type { IProductItem } from './config';

export const productsAc: Record<string, IProductItem[]> = {
    eu: [
        {
            variantId: '50510963605847',
            name: 'EcoFlow STREAM AC Pro',
            tips: '',
            desc: '1 × EcoFlow STREAM AC Pro (1,92 kWh)',
            save: 'Capacity: 1.92kWh',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50396945482071&purchaseOption=691099697495',
            descList: ['2,300W', '100%', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50511130329431',
            name: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            tips: '',
            desc: 'EcoFlow STREAM Ultra (1,92 kWh) + STREAM AC Pro (1,92 kWh)',
            save: 'Save up to €793 annually',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703172439&purchaseOption=691099697495',
            descList: ['100%', '1,983kWh', '1,977 kg'],
        },
        {
            variantId: '50511302000983',
            name: 'EcoFlow STREAM AC Pro + 2 × 450W Rigid Solar Panel + STREAM Microinverter',
            tips: '',
            desc: 'EcoFlow STREAM AC Pro (1,92kWh)+ 2 × 450W Rigid Solar Panel + STREAM Microinverter (800W)',
            save: 'Save up to €319 annually',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703139671&purchaseOption=691099697495',
            descList: ['33,4%', '798kWh', '795 kg'],
        },
    ],
    uk: [
        {
            variantId: '50839544365395',
            name: 'EcoFlow STREAM AC Pro',
            desc: '1 x EcoFlow STREAM AC Pro (1.92 kWh)',
            tips: '',
            save: 'Capacity: 1.92kWh',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50758705021267&purchaseOption=690042765651',
            descList: ['33,4%', '1.041kWh', '1.037 kg'],
            noPanels: true,
        },
        {
            variantId: '50839544398163',
            name: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            desc: 'EcoFlow STREAM Ultra (1.92 kWh) + STREAM AC Pro (1.92 kWh) ',
            tips: '',
            save: 'Save up to ￡681 annually',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613836627&purchaseOption=690042765651',
            descList: ['2,300W', '100%', 'IP65'],
        },
        {
            variantId: '50839544430931',
            name: 'EcoFlow STREAM AC Pro + 2 × 450W Rigid Solar Panel + STREAM Microinverter',
            desc: 'EcoFlow STREAM AC Pro (1.92kWh)+ 2 × 450W Rigid Solar Panel + STREAM Microinverter (800W)',
            tips: '',
            save: 'Save up to ￡272 annually',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613803859&purchaseOption=690042765651',
            descList: ['33,4%', '798kWh', '795 kg'],
        },
    ],
    de: [
        {
            variantId: '55835191804285',
            name: 'EcoFlow STREAM AC Pro',
            desc: '1 x EcoFlow STREAM AC Pro (1 920 Wh)',
            tips: '',
            save: 'Kapazität: 1,92 kWh',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55738978959741&purchaseOption=710509658493',
            descList: ['2.300 W', '100 %', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '55835191837053',
            name: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            desc: 'EcoFlow STREAM Ultra (1 920 Wh) + STREAM AC Pro (1 920 Wh)',
            tips: '',
            save: 'Bis zu 793 € jährlich sparen',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410618749&purchaseOption=710509658493',
            descList: ['100 %', '1 983 kWh', '1 977 kg'],
        },
        {
            variantId: '55835191869821',
            name: 'EcoFlow STREAM AC Pro + 2 × 450 W Starres Solarpanel + STREAM Mikro-Wechselrichter',
            desc: 'EcoFlow STREAM AC Pro (1 920 Wh)+ 2 × 450 W Starres Solarpanel + STREAM Mikro-Wechselrichter (800 W)',
            tips: '',
            save: 'Sparen Sie jährlich bis zu 319 €',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410585981&purchaseOption=710509658493',
            descList: ['33,4 %', '798 kWh', '795 kg'],
        },
    ],
    fr: [
        {
            variantId: '50473476751707',
            name: 'EcoFlow STREAM AC Pro',
            desc: '1 x EcoFlow STREAM AC Pro (1 920 Wh)',
            tips: '',
            save: `Capacité : 1,92 kWh`,
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50393675891035&purchaseOption=693334770011',
            descList: ['2 300 W', '100 %', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50473476784475',
            name: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            desc: 'EcoFlow STREAM Ultra (1 920 Wh) + STREAM AC Pro (1 920 Wh)',
            tips: '',
            save: `Économisez jusqu'à 506 € par an`,
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857093467&purchaseOption=693334770011',
            descList: ['100 %', '2 840 kWh', '1 977 kg'],
        },
        {
            variantId: '50473476817243',
            name: 'EcoFlow STREAM AC Pro + 2 panneaux solaires rigides 450 W + Micro-onduleur STREAM',
            desc: 'EcoFlow STREAM AC Pro (1 920 Wh) + 2 panneaux solaires rigides 450 W + Micro-onduleur STREAM (800 W)',
            tips: '',
            save: `Économisez jusqu'à 206 € par an`,
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857060699&purchaseOption=693334770011',
            descList: ['33,4 %', '1 053 kWh', '795 kg'],
        },
    ],
    it: [
        {
            variantId: '55029657862520',
            name: 'EcoFlow STREAM AC Pro',
            desc: '1 × EcoFlow STREAM AC Pro (1.920 Wh)',
            tips: '',
            save: 'Capacità: 1,92 kWh',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=55011791634808&purchaseOption=710883574136',
            descList: ['2.300 W', '100 %', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '55029657895288',
            name: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            desc: 'EcoFlow STREAM Ultra (1.920 Wh) + STREAM AC Pro (1.920 Wh)',
            tips: '',
            save: 'Risparmia fino a 793 € l’anno',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832328568&purchaseOption=710883574136',
            descList: ['100%', '1.983 kWh', '1.977 kg'],
        },
        {
            variantId: '55029657928056',
            name: 'EcoFlow STREAM AC Pro + 2 pannelli solari rigidi da 450 W + Microinverter STREAM',
            desc: 'EcoFlow STREAM AC Pro (1.920 Wh) + 2 pannelli solari rigidi da 450 W + Microinverter STREAM (600 W)',
            tips: '',
            save: 'Risparmia fino a 319 € l’anno',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832295800&purchaseOption=710883574136',
            descList: ['33,4%', '798 kWh', '795 kg'],
        },
    ],
    es: [
        {
            variantId: '50473428779355',
            name: 'EcoFlow STREAM AC Pro',
            desc: '1 × EcoFlow STREAM AC Pro (1920 Wh)',
            tips: '',
            save: 'Capacidad: 1,92 kWh',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50393711870299&purchaseOption=693334802779',
            descList: ['2.300 W', '100 %', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50473428812123',
            name: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            desc: 'EcoFlow STREAM Ultra (1920 Wh) + STREAM AC Pro (1920 Wh)',
            tips: '',
            save: 'Ahorra hasta 793 € al año',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854832475&purchaseOption=693334802779',
            descList: ['100 %', '1983 kWh', '1977 kg'],
        },
        {
            variantId: '50473428844891',
            name: 'EcoFlow STREAM AC Pro + 2 paneles solares rígidos de 450 W + Microinversor STREAM',
            desc: 'EcoFlow STREAM AC Pro (1920 Wh) + 2 paneles solares rígidos de 450 W + Microinversor STREAM (800 W)',
            tips: '',
            save: 'Ahorra hasta 319 € al año',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854799707&purchaseOption=693334802779',
            descList: ['33,4 %', '798 kWh', '795 kg'],
        },
    ],
};
